import { Form, Formik } from "formik";
import { AuthForm } from "./Components";
import * as Yup from "yup";
import FormInput from "../../components/Form/FormInput/FormInput";
import PasswordInput from "../../components/Form/FormInput/PasswordInput";
import PrimaryButton from "../../components/Form/Button/PrimaryButton";
import { useTranslation } from "react-i18next";
import YupValidation from "../../components/Form/Validations/YupValidaion";
import { ROUTES } from "../../services/constants";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
const Auth = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {login} = useAuth();
    const initialValues = {
        email: "",
        password: ""
    };

    const validationSchema = Yup.object({
        email: YupValidation.EmailValidation(),
        password: Yup.string().min(8, t("min_length", {field: t("Password"), min: 8})).required(t("field_required", {field: t("Password")}))
    });

    const handleSubmit = (values, actions) => {
        login(values, actions, (user) => {
            navigate(ROUTES.DASHBOARD);
        })
    };
    return (
        <AuthForm>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {(formik) => (
                    <Form>
                        <FormInput type="text" name="email" label={t("E-Mail")} forceLTR={true} formik={formik}/>
                        <PasswordInput name="password" label={t("Password")} formik={formik}/>
                        <PrimaryButton type="submit" full submitting={formik.isSubmitting}>{t("Login")}</PrimaryButton>
                    </Form>
                )}
                
            </Formik>
        </AuthForm>
    )
}
export default Auth;